import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';

const SOCIAL = [
  {
    label: 'WhatsApp',
    href: 'https://wa.me/6281322443651',
    color: '#25D366',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://instagram.com/doitcre',
    color: '#E1306C',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    label: 'TikTok',
    href: null,
    color: '#f0f0f8',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.74a4.85 4.85 0 01-1.01-.05z"/>
      </svg>
    ),
  },
  {
    label: 'Gmail',
    href: 'mailto:bramastaspace@gmail.com',
    color: '#EA4335',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 010 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z"/>
      </svg>
    ),
  },
];

function SocialIcon({ item }) {
  const [hovered, setHovered] = useState(false);
  const Wrapper = item.href ? motion.a : motion.div;
  const wrapperProps = item.href ? { href: item.href, target: '_blank', rel: 'noreferrer' } : {};

  return (
    <Wrapper
      {...wrapperProps}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      whileHover={{ y: -6, scale: 1.08 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
        textDecoration: 'none', cursor: item.href ? 'pointer' : 'default',
        opacity: item.href ? 1 : 0.35,
      }}
    >
      <div style={{
        width: '64px', height: '64px', borderRadius: '18px',
        background: hovered ? `${item.color}22` : 'rgba(255,255,255,0.03)',
        border: `1px solid ${hovered ? item.color + '55' : 'rgba(255,255,255,0.08)'}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: hovered ? item.color : 'rgba(240,240,248,0.5)',
        transition: 'all 0.25s ease',
        boxShadow: hovered ? `0 0 24px ${item.color}33` : 'none',
      }}>
        {item.icon}
      </div>
      <span style={{
        fontFamily: "'Share Tech Mono', monospace", fontSize: '10px',
        letterSpacing: '0.15em', textTransform: 'uppercase',
        color: hovered ? item.color : 'rgba(240,240,248,0.3)',
        transition: 'color 0.25s',
      }}>
        {item.label}
      </span>
    </Wrapper>
  );
}

export default function ContactSection() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      // Simple mailto fallback — opens mail client with prefilled content
      const subject = encodeURIComponent(`Message from ${form.name} via DOIT Website`);
      const body = encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\nMessage:\n${form.message}`);
      window.location.href = `mailto:bramastaspace@gmail.com?subject=${subject}&body=${body}`;
      setStatus('sent');
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  const inputStyle = {
    width: '100%', padding: '14px 18px',
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '14px',
    color: '#f0f0f8', fontFamily: "'Mona Sans', sans-serif",
    fontSize: '14px', outline: 'none',
    transition: 'border-color 0.25s, background 0.25s',
  };

  return (
    <section id="contact" style={{ background: '#04080f', padding: '120px 48px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <div style={{ maxWidth: '860px', margin: '0 auto' }}>

        {/* header */}
        <p style={{ fontFamily: "'Share Tech Mono', monospace", fontSize: '11px', letterSpacing: '0.2em', color: '#325998', marginBottom: '14px', textTransform: 'uppercase' }}>
          Get In Touch
        </p>
        <h2 style={{ fontFamily: "'Mona Sans', sans-serif", fontWeight: 800, fontSize: 'clamp(36px, 5vw, 64px)', letterSpacing: '-0.025em', color: '#f0f0f8', marginBottom: '12px', lineHeight: 1.0 }}>
          Let's build something
          <br /><span style={{ color: 'rgba(240,240,248,0.25)' }}>together.</span>
        </h2>
        <p style={{ fontSize: '14px', color: 'rgba(240,240,248,0.4)', marginBottom: '56px', lineHeight: 1.7 }}>
          Ready to take your brand to the next level? Drop us a message.
        </p>

        {/* social icons row */}
        <div style={{ display: 'flex', gap: '32px', justifyContent: 'center', marginBottom: '64px', flexWrap: 'wrap' }}>
          {SOCIAL.map(item => <SocialIcon key={item.label} item={item} />)}
        </div>

        {/* divider */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '48px' }}>
          <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.06)' }} />
          <span style={{ fontFamily: "'Share Tech Mono', monospace", fontSize: '10px', letterSpacing: '0.2em', color: 'rgba(240,240,248,0.2)' }}>OR SEND A MESSAGE</span>
          <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.06)' }} />
        </div>

        {/* form */}
        <form ref={formRef} onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            <input
              type="text" placeholder="Your Name" required value={form.name}
              onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
              onFocus={e => { e.target.style.borderColor = 'rgba(50,89,152,0.6)'; e.target.style.background = 'rgba(255,255,255,0.05)'; }}
              onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.08)'; e.target.style.background = 'rgba(255,255,255,0.03)'; }}
              style={inputStyle}
            />
            <input
              type="email" placeholder="Your Email" required value={form.email}
              onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
              onFocus={e => { e.target.style.borderColor = 'rgba(50,89,152,0.6)'; e.target.style.background = 'rgba(255,255,255,0.05)'; }}
              onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.08)'; e.target.style.background = 'rgba(255,255,255,0.03)'; }}
              style={inputStyle}
            />
          </div>
          <textarea
            placeholder="Tell us about your project..." required value={form.message} rows={5}
            onChange={e => setForm(p => ({ ...p, message: e.target.value }))}
            onFocus={e => { e.target.style.borderColor = 'rgba(50,89,152,0.6)'; e.target.style.background = 'rgba(255,255,255,0.05)'; }}
            onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.08)'; e.target.style.background = 'rgba(255,255,255,0.03)'; }}
            style={{ ...inputStyle, resize: 'vertical', minHeight: '140px' }}
          />
          <motion.button
            type="submit"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            disabled={status === 'sending'}
            style={{
              padding: '16px 32px', borderRadius: '14px',
              background: status === 'sent' ? 'rgba(50,89,152,0.3)' : 'rgba(50,89,152,0.2)',
              border: '1px solid rgba(50,89,152,0.5)',
              color: '#f0f0f8', fontFamily: "'Mona Sans', sans-serif",
              fontSize: '14px', fontWeight: 600, cursor: 'pointer',
              letterSpacing: '0.04em', alignSelf: 'flex-start',
              backdropFilter: 'blur(12px)', transition: 'all 0.25s',
            }}
          >
            {status === 'sending' ? 'Opening...' : status === 'sent' ? '✓ Message Ready' : 'Send Message →'}
          </motion.button>
        </form>
      </div>
    </section>
  );
}
